import {locale} from 'shared/core';

const SUPPORT_CENTRE_BASE_URL = `https://support.collage.co/${locale}`;

export function supportCentreCollectionUrl(collectionId) {
  if (!collectionId) return SUPPORT_CENTRE_BASE_URL;

  return `${SUPPORT_CENTRE_BASE_URL}/collections/${collectionId}`;
}

export function supportCentreArticleUrl(articleId) {
  return `${SUPPORT_CENTRE_BASE_URL}/articles/${articleId}`;
}
